<template>
  <ul
    role="list"
    :class="computedClasses"
  >
    <slot />
  </ul>
</template>

<script setup lang="ts">
import type { ListContainerGap, ListContainerVariant } from './types'

const props = withDefaults(defineProps<{
  variant?: ListContainerVariant
  gap?: ListContainerGap
}>(), {
  variant: 'default',
  gap: 'md',
})

const computedSpaceClass = computed(() => {
  if (props.variant === 'separated') {
    return [
      { 'space-y-4': props.gap === 'md' },
      { 'space-y-6': props.gap === 'lg' },
    ]
  }

  return []
})

const computedClasses = computed(() => {
  return [
    {
      'divide-y divide-gray-200': props.variant === 'divide',
    },
    [...computedSpaceClass.value],
  ]
})
</script>
